import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  profileId: number;
  file: File;
  additional_document: number;
  description?: string;
}

export const useUploadProfileDocument = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    const formData = new FormData();

    formData.append("additional_document", String(params.additional_document));
    formData.append("profile", String(params.profileId));
    formData.append("document", params.file);

    if (params.description) {
      formData.append("description", params.description);
    }

    return axios.post(
      `${env.verifyServiceUrl}individual/profile_document/`,
      formData,
      {
        headers: {
          Authorization: authHeader,
        },
      },
    );
  });
};
